// extracted by mini-css-extract-plugin
export default {"wrapper":"xbaSxd9etn7pGz5pfiru"};